export default "__VITE_ASSET__JU1KUFd1__"